import { Cell, FormControl, Grid, isEmpty, VFlow } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { ErrorField } from 'components/form'
import { CboCuidadoCompartilhadoSelectModel } from 'components/form/field/select/CboCuidadoCompartilhadoSelectField/CboCuidadoCompartilhadoSelectField'
import { CiapSelectField } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { CidSelectField } from 'components/form/field/select/CidSelectField/CidSelectField'
import { CiapCapituloEnum } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { Fragment } from 'react'
import { useField } from 'react-final-form'
import { MetaRoot } from 'util/metaPath'

import { CuidadoCompartilhadoPlanoModel } from '../model-cuidadocompartilhado'
import { canRegisterCid10 } from './utils-cuidadoCompartilhado'

interface CuidadoCompartilhadoProblemasCondicoesFieldsProps {
  path: MetaRoot<CuidadoCompartilhadoPlanoModel>
  isGuiaEncaminhamento: boolean
  isEdit: boolean
  disabled: boolean
}

export default function CuidadoCompartilhadoProblemasCondicoesFields(
  props: Readonly<CuidadoCompartilhadoProblemasCondicoesFieldsProps>
) {
  const { path, isGuiaEncaminhamento, isEdit, disabled } = props

  const {
    acesso: {
      cbo: { cbo2002 },
    },
  } = useAcessoLotacaoOrEstagio()

  const { cidadao } = useAtendimentoContext()

  const {
    input: { value: ciapValue },
  } = useField<CboCuidadoCompartilhadoSelectModel>(path.problemasECondicoes.ciap.absolutePath(), {
    subscription: { value: true },
  })

  const identidadeGeneroEmpty = isEmpty(cidadao?.identidadeGeneroDbEnum)
  const sexoCidadao = identidadeGeneroEmpty ? cidadao?.sexo : null
  const idadeEmAnos = cidadao.idadeEmAnos
  const ciapId = ciapValue?.id

  const canAcessoCBORegisterCid10 = canRegisterCid10(cbo2002)
  const cid10DisabledNotGuia = disabled || !canAcessoCBORegisterCid10

  return (
    <Cell size={12}>
      <VFlow vSpacing={0.5}>
        <FormControl label='Problemas/condições' required>
          <Grid>
            {isGuiaEncaminhamento ? (
              <Cell size={6}>
                <CidSelectField
                  name={path.problemasECondicoes.cid10}
                  label='CID 10'
                  idadeCidadaoEmAnos={idadeEmAnos}
                  sexo={sexoCidadao}
                  disabled={disabled}
                />
              </Cell>
            ) : (
              <Fragment>
                <Cell size={6}>
                  <CiapSelectField
                    name={path.problemasECondicoes.ciap}
                    label='CIAP 2'
                    idadeCidadaoEmAnos={idadeEmAnos}
                    sexo={sexoCidadao}
                    capitulosExcluidos={[CiapCapituloEnum.PROCEDIMENTOS]}
                    excluirCIAPsDAB
                    menuMinWidth={620}
                    disabled={disabled}
                  />
                </Cell>
                {(canAcessoCBORegisterCid10 || isEdit) && (
                  <Cell size={6}>
                    <CidSelectField
                      name={path.problemasECondicoes.cid10}
                      label='CID 10'
                      renderGrupoCiapRelacionada
                      idadeCidadaoEmAnos={idadeEmAnos}
                      ciapRelacionada={ciapId}
                      sexo={sexoCidadao}
                      disabled={cid10DisabledNotGuia}
                    />
                  </Cell>
                )}
              </Fragment>
            )}
          </Grid>
        </FormControl>
        <ErrorField name={path.problemasECondicoes} ignoreObjectError />
      </VFlow>
    </Cell>
  )
}
